import { stylesheet } from 'typestyle';
import { Gray120, Select, TextArea, typeBase10MediumCapsProperties } from '@traceair/tds';
import { Dispatch, SetStateAction } from 'react';
import { RescheduleReason } from '../../../../consts/RescheduleReason';

const REASONS = [
  {
    label: 'Bad weather',
    value: RescheduleReason.BadWeather,
    description: 'The flight can’t be done due to rain, strong wind, low visibility, or other poor weather conditions',
  },
  {
    label: 'Winter conditions',
    value: RescheduleReason.WinterCondition,
    description: 'Client asked to delay the flight if there is snow on site',
  },
  {
    label: 'Flight Marker delay',
    value: RescheduleReason.FlightMarkerDelay,
    description: 'Flight Markers are not ready for the scan',
  },
  {
    label: 'Equipment issue',
    value: RescheduleReason.EquipmentIssue,
    description: 'Drone or related equipment is not functioning properly',
  },
  {
    label: 'Other reason',
    value: RescheduleReason.Other,
  },
];

const css = stylesheet({
  container: {
    marginBottom: 12,
  },
  heading: {
    ...typeBase10MediumCapsProperties,
    marginBottom: 8,
    paddingLeft: 12,
    color: Gray120,
  },
  select: {
    marginBottom: 8,
  },
});

interface Props {
  reason?: string;
  setReason: Dispatch<SetStateAction<string | undefined>>;
  note: string;
  setNote: Dispatch<SetStateAction<string>>;
  isNoteRequired: boolean;
}

export const DateChangeReason = ({ reason, setReason, note, setNote, isNoteRequired }: Props) => {
  const notePlaceholderPostfix = isNoteRequired ? '(required)' : '(optional)';

  return (
    <div className={css.container}>
      <div className={css.heading}>Reason for rescheduling</div>

      <Select
        value={reason}
        onChange={setReason}
        className={css.select}
        placeholder="Select reason"
        options={REASONS}
      />

      <TextArea value={note} onChange={setNote} placeholder={`Additional note ${notePlaceholderPostfix}`} />
    </div>
  );
};
